/** Format angka ke tampilan Rupiah Indonesia: 6000000 → 6.000.000 */
export const formatNominalInput = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const digits = String(value).replace(/\D/g, '');
  if (!digits) return '';
  return Number(digits).toLocaleString('id-ID');
};

/** Parse input berformat ke angka bulat */
export const parseNominalInput = (value) => {
  const digits = String(value).replace(/\D/g, '');
  return digits ? Number(digits) : 0;
};
